import React from 'react'
import { Copilot } from '../copilot/Copilot';
import { Assistant } from '../assistant/Assistant'
import { DocumentAnalysis } from '../documentanalysis/DocumentAnalysis'
import { Footer } from '../../main/footer/Footer';
import { CommonTasks } from '../../main/commontasks/CommonTasks';

import { AIQuiz } from '../../main/aiquiz/AIQuiz';
import { AITest } from '../../main/aitest/AITest';
import { Translation } from '../../main/translation/Translation';
import { CustomTemplates } from '../../main/customtemplates/CustomTemplates';
import { ContactUs } from '../../main/contactus/ContactUs';
import { AboutUs } from '../../main/aboutus/AboutUs';
import { Home } from '../../main/home/Home';
import { Pay } from '../../main/pay/Pay';
//import { CreditsSuccess } from '../../main/credits_success/CreditsSuccess';
import { BuyTestSuccess } from '../aitest/BuyTestSuccess';
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import {NavBar} from '../../layout/NavBar'
import { CheckoutSession } from '../../main/purchasetest/CheckoutSession';
import { BetterResponses } from '../betterresponses/BetterResponses';
import './maincontainer.css'
import 'bootstrap/dist/css/bootstrap.min.css'
import ScrollToTop from '../../../ScrollToTop'

import {Return} from '../purchasetest/Return'
//import {TestBought} from '../purchasetest/TestBought'
import {Refresh} from '../purchasetest/Refresh'
import CompareAI from '../compareai/CompareAI';
import { ComprehensiveResponses } from '../comprehenisveresponses/ComprehensiveResponses';
import { BuyMyTest } from '../../main/buymytest/BuyMyTest';
import { MyTestPage } from '../../main/mytestpage/MyTestPage';
import { JobInterview } from '../../main/jobinterview/JobInterview';
import StocksTemplates from '../stocks/StocksTemplates';
import { Marketing } from '../marketing/Marketing'

export const MainContainer = () => {
    return (
        <div className="mainConainer">
       
          <NavBar />
            <Router>
                <ScrollToTop />
                <div>
                    <Routes>   
                        <Route path="/comprehensiveresponses" element={<ComprehensiveResponses />} />
                        <Route path="/compareai" element={<CompareAI />} />             
                        <Route path="/copilot" element={<Copilot />} />
                        <Route path="/documentanalysis" element={<DocumentAnalysis />} />
                        <Route path="/assistant" element={<Assistant />} />
                        <Route path="/common" element={<CommonTasks />} />
                        <Route path="/translation" element={<Translation />} />
                        
                        <Route path="/templates" element={<CustomTemplates />} />
                        <Route path="/contactus" element={<ContactUs />} />
                        <Route path="/aboutus" element={<AboutUs />} />
                        <Route path="/aitest/:token" element={<AITest />} />

                        <Route path="/home/:token" element={<Home />} />
                        <Route path="/" element={<Home />} />
                        
                        <Route path="/pay/:value" element={<Pay />} />

                        <Route path="/aiquiz" element={<AIQuiz />} />
                        <Route path="/betterresponses" element={<BetterResponses />} /> 
                        
                        {/*<Route path="/creditssuccess" element={<CreditsSuccess />} />*/}
                        <Route path="/buytestsuccess" element={<BuyTestSuccess />} />    
                        
                        <Route path="/return/:connectedAccountId" element={<Return />} />
                        <Route path="/refresh/:connectedAccountId" element={<Refresh />} />

                        <Route path="/checkoutsession/:creator_id/:price/:testname" element={<CheckoutSession />} />
                        <Route path="/return?" element={<Return />} />
                        {/*<Route path="/testbought?" element={<TestBought />} />*/}

                        <Route path="/buymytest/:value/:testname/:testcreatorid/:creatorname/:chatauthorkey" element={<BuyMyTest />} />
                        
                        <Route path="/mytestpage" element={<MyTestPage />} />
                        <Route path="/jobinterview" element={<JobInterview />} />
                        <Route path="/stocks" element={<StocksTemplates />} />
                        <Route path="/marketing" element={<Marketing />} />
                        
                    </Routes>
                    <Footer />
                </div>

            </Router>
            
            </div>
       
    )
}